export function isEdge() {
  return typeof navigator !== "undefined" && /Edg\//.test(navigator.userAgent)
}

export function isMobileUserAgent() {
  if (typeof navigator === "undefined") return false
  if (navigator.userAgentData?.mobile) return true
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
